import React, { useState,useRef } from 'react';
import {
  doc, getDoc, getFirestore, collection, addDoc,
  serverTimestamp, query, where, getDocs
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import {
  getStorage, ref, uploadString
} from 'firebase/storage';
import BackHomeButton from '../components/BackHomeButton';
import Get_Help from '../components/Get_Help';
import Help_Video from '../components/Help_Video';
import { db, auth } from '../firebase';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackClick } from './trackClick';

import { functions } from '../firebase'; // Ensure path is correct
import { httpsCallable } from 'firebase/functions';

function CheckMyAnswer() {
  const [subject, setSubject] = useState('');
  const [Question, setQuestion] = useState('');
  const [Answer, setAnswer] = useState('');
  const [aiResult, setAiResult] = useState('');
  const [message, setMessage] = useState('');
  const [standard, setStandard] = useState('unspecified');
  const [school, setSchool] = useState('unspecified');
  const [savedLessons, setSavedLessons] = useState([]);
  const [selectedLessonId, setSelectedLessonId] = useState('');
  const [selectedLessonText, setSelectedLessonText] = useState('');

  const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    const [previews, setPreviews] = useState([]);
    const [text, setText] = useState('');
    const textAreaRef = useRef(null);



  //const auth = getAuth();
  //const db = getFirestore();
  const storage = getStorage();
  const user = auth.currentUser;

    const extractTextFromImages = async () => {
  let combinedText = '';

  setLoading(true);

  const prompt = `This is an image of an answer sheet with questions and 
  answers .  Extract all questions and answers only as text from these images as plain text only.`;

  const callGemini = httpsCallable(functions, 'callGemini');

  for (let file of files) {

    const base64 = await getBase64(file);

    //alert(base64);

      // ✅ Prepare Gemini payload
      const payload = {
        contents: [
          {
            role: "user",
            parts: [
              { text: prompt },
              {
inlineData: {
  mimeType: file.type || "image/jpeg",
  data: base64,
}
              },
            ],
          },
        ],
      };

      // ✅ Call your backend Cloud Function (replace with your deployed URL)
const result = await callGemini(payload);
const data = result.data;
      // ✅ Extract text from Gemini response
    const text =
       data?.candidates?.[0]?.content?.parts?.[0]?.text || "No text found.";

       //alert(text);

      combinedText += text + "\n";
  }

  setText((prev) => prev + '\n' + combinedText);

  setLoading(false);

  setQuestion(combinedText);

  // autofocus textarea after AI fills it
  setTimeout(() => {
    textAreaRef.current?.focus();
  }, 0);
};

  function getBase64(fileObj) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      const parts = result.split(",");
      resolve(parts.length > 1 ? parts[1] : result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(fileObj);
  });
}

  const handleRemoveImage = (index) => {
  setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
};

  const handleFilesChange = (e) => {
  const selectedFiles = Array.from(e.target.files);
  const validFiles = selectedFiles.filter((f) => f.size <= 5 * 1024 * 1024);

  if (validFiles.length < selectedFiles.length) {
    alert('❌ Please upload files below 5MB only');
  }

  setFiles((prevFiles) => [...prevFiles, ...validFiles]);
  setPreviews((prevPreviews) => [
    ...prevPreviews,
    ...validFiles.map((f) => URL.createObjectURL(f)),
  ]);
};

  const location = useLocation();

    const [subjectList, setSubjectList] = useState([]);
  
    useEffect(() => {
      const fetchSubjects = async () => {
        try {
          if (!standard) return; // Don't fetch unless we have the user's standard
  
          const q = query(collection(db, 'Standard_Subject_Topic_Master'), where('Standard', '==', parseInt(standard)));
          const snapshot = await getDocs(q);
          const subjectsData = snapshot.docs.map(doc => doc.data().Subject);
          // Deduplicate and sort
          const uniqueSortedSubjects = [...new Set(subjectsData)].sort();
  
          setSubjectList(uniqueSortedSubjects);
        } catch (error) {
          console.error('Error fetching subjects:', error);
        }
      };
  
      fetchSubjects();
    }, [standard]);

  
async function fetchAIResponse(prompt) {

  const callGemini = httpsCallable(functions, 'callGemini');

  // 2. Try Gemini as fallback
  try {
    const result = await callGemini({
      contents: [{ role: "user", parts: [{ text: prompt }] }],
      generationConfig: {
        maxOutputTokens: 8192,
        temperature: 0.7
      }
    });

    // 🛡️ Secure Note: The App Check token was sent automatically!
    // result.data contains the body of the response from your backend
    return result.data.candidates?.[0]?.content?.parts?.[0]?.text;

  } catch (err) {
    console.error('Gemini error:', err.message);
    
    // Check for specific security failures
    if (err.code === 'failed-precondition') {
      alert("Security Check Failed: Please refresh the page.");
    }
  }

  // If both fail
  alert("Oops All AI engines are busy for now .Please try in a couple of minutes.");
  return null;
}
  
  useEffect(() => {
    const state = location.state;
    if (state) {
      if (state.selectedLessonId) setSelectedLessonId(state.selectedLessonId);
      if (state.subject) setSubject(state.subject);
    }
  }, [location.state]);

  useEffect(() => {
    if (selectedLessonId && savedLessons.length > 0) {
      const selected = savedLessons.find(l => l.id === selectedLessonId);
      if (selected) {
        setSelectedLessonText(selected.text || '');
      }
    }
  }, [savedLessons, selectedLessonId]);

  useEffect(() => {
  const fetchProfile = async () => {
    if (!user) return;

    try {
      const profileRef = doc(db, 'profiles', user.uid);
      const profileSnap = await getDoc(profileRef);
      if (profileSnap.exists()) {
        const profileData = profileSnap.data();
        setStandard(profileData.standard || 'unspecified');
        setSchool(profileData.school || 'unspecified');
      }
    } catch (err) {
      console.error('Error fetching user profile:', err);
    }
  };

  fetchProfile();
}, [user,standard,db]);


useEffect(() => {
  const fetchSavedLessons = async () => {
    if (!user) return;

    const coreSubjects = ['English Language', 'Hindi Language',  'Maths'];

    const snapshot = await getDocs(collection(db, 'Saved_lessons'));
    const lessons = snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(item =>
        (item.email === user.email || item.sharedWith === 'parents') &&
        item.school === school &&
        (
          coreSubjects.includes(item.subject) || 
          item.standard === standard
        )
      );
      setSavedLessons(lessons);
      }

  fetchSavedLessons();
}, [user,standard,db]);


  const handleGenerate = async () => {
    try {
      const profileRef = doc(db, 'profiles', user?.uid);
      const profileSnap = await getDoc(profileRef);
      if (profileSnap.exists()) {
        const profileData = profileSnap.data();
        setStandard(profileData.standard || 'unspecified');
      }
    } catch (err) {
      console.error('Error fetching user profile:', err);
    }

    if (!subject || !Question || !selectedLessonId) {
      alert('Please Provide Subject,Lesson, Question  and Answer ');
      return;
    }

    let prompt = `I will give you the question , answer , the subject and the optional Lesson on which the question is based on.
     You need to check the provided question and the answer and reply if the answer is correct or not with an explanation of your decision.
     Remember this is for a student of standard ${standard}. 
     Please only use the given information and do not hallucinate or add extra details. 
     Do not use foul language and do not give any suggestions in your reply.
     Alwasy reply in the language of the lesson.\n `;

      prompt += `Here is a lesson passage for context:\n${selectedLessonText}\n.
       if the user chooses 'Use Without a lesson' or when Subject is other than  Literature,GK,EVS,Computer
       you can ignore this lesson text.\n`;

    prompt += `These are the question's and answers :  \n${Question}\n`

    prompt += `Also please give the correct answer of the question in the bottom thanks`

    setMessage(`Checking Answer's...`);    

    try {

      const content = await fetchAIResponse(prompt);

      if (!content) {
        alert('Failed to generate response from AI.');
        setMessage('AI did not return a response.');
        return;
      }

      setAiResult(content);

      const docRef = await addDoc(collection(db, 'ai_checked_answers'), {
        userId: user?.uid || 'anonymous',
        subject,
        Question,
        Answer,
        content,
        timestamp: serverTimestamp()
      });

      const storageRef = ref(storage, `ai_worksheets/${user?.uid}/${docRef.id}.txt`);
      await uploadString(storageRef, content);

      setMessage('Answer Check successful!');
      
    } catch (err) {
      console.error(err);
      alert('Something went wrong: ' + err.message);
      setMessage('Failed to Check. Please try again.');
    }
  };

return (
    <>
      <div className="min-h-screen bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-indigo-50 via-slate-50 to-white py-2 sm:py-6 px-2 sm:px-6 lg:px-8 font-sans">
        
        <div className="w-full mx-auto max-w-5xl bg-white/80 backdrop-blur-xl rounded-[1rem] sm:rounded-[2rem] shadow-2xl shadow-indigo-500/10 border border-white p-3 sm:p-8 relative overflow-hidden">
          
          {/* Top Nav & Header - Balanced Flex Layout */}
          <div className="flex items-center justify-between mb-2 sm:mb-4 w-full gap-2">
            <div className="flex-1 flex justify-start min-w-0">
              <BackHomeButton
                backState={{ selectedLessonId, subject }}
              />
            </div>
            <div className="flex-auto text-center px-1 sm:px-4 shrink-0">
              <h2 className="text-sm sm:text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight leading-tight whitespace-nowrap">
                Check My <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-violet-600">Answer</span>
              </h2>
            </div>
            <div className="flex-1 flex justify-end min-w-0"><Get_Help/></div>
          </div>

          <div className="text-center mb-6 sm:mb-8">
            <p className="text-[10px] sm:text-sm text-slate-500 font-medium w-full mx-auto px-2">
              <strong className="text-slate-700">AI can make mistakes.</strong> Please verify its explanation and retry if needed.
            </p>
          </div>
{/*
          // Drop your reusable component here 
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>
            <Help_Video 
              videoId="o6MIAVDIHwc?si=n1l6d7RWL0bIn8qm" 
              title="How to use Voice to Text" 
            />
          </div>

          <br></br>
*/}
          {/* Configuration Grid: Subject & Lesson */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-6 mb-6 sm:mb-8 max-w-4xl mx-auto">
            
            {/* Subject Dropdown */}
            <div className="space-y-1 sm:space-y-2">
              <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Choose Subject</label>
              <select
                value={subject}
                onChange={(e) => {
                  setSubject(e.target.value);
                  setSelectedLessonId("");
                  setSelectedLessonText("");
                }}
                className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10 transition-all outline-none text-[11px] sm:text-base font-semibold text-slate-700 cursor-pointer appearance-none"
              >
                <option value="">-- Select Subject --</option>
                {[...new Set([...subjectList, "English Language", "Hindi Language", "Maths"])].sort().map((subj, idx) => (
                  <option key={idx} value={subj}>{subj}</option>
                ))}
              </select>
            </div>

            {/* Lesson Dropdown */}
            {subject && (
              <div className="space-y-1 sm:space-y-2 animate-in fade-in zoom-in-95 duration-200">
                <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Lessons under {subject}</label>
                <select
                  value={selectedLessonId}
                  onChange={(e) => {
                    const selected = savedLessons.find(l => l.id === e.target.value);
                    if (e.target.value === 'Use without a Lesson' || e.target.value === "") {
                      setSelectedLessonId(e.target.value);
                      setSelectedLessonText(""); 
                    } else {
                      setSelectedLessonId(e.target.value);
                      setSelectedLessonText(selected?.text || "");
                    }
                  }}
                  className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl px-2 py-1.5 sm:px-3 sm:py-3 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/10 transition-all outline-none text-[11px] sm:text-base font-semibold text-slate-700 cursor-pointer appearance-none"
                >
                  <option value="">-- Select a Lesson --</option>
                  {savedLessons.filter((lesson) => lesson.subject === subject).sort((a, b) => (a.lessonName || '').localeCompare(b.lessonName || '')).map((lesson) => (
                    <option key={lesson.id} value={lesson.id}>
                      Lesson Name - {lesson.lessonName || 'No Title'}
                    </option>
                  ))}
                  {savedLessons.filter((lesson) => lesson.subject === subject).length === 0 && (
                    <option value="Use without a Lesson">Use without a lesson</option>
                  )}
                </select>
              </div>
            )}
          </div>

          {/* Image Upload Zone */}
          <div className="max-w-4xl mx-auto mb-6 sm:mb-8 bg-indigo-50/50 border border-indigo-100 p-3 sm:p-5 rounded-xl sm:rounded-2xl shadow-sm">
            <label className="block text-[11px] sm:text-sm font-bold text-indigo-900 mb-2 sm:mb-4">Upload Images of Question & Answer</label>
            
            <div className="flex items-center gap-3 sm:gap-4 flex-wrap">
              {/* Custom File Upload Button */}
              <label className="flex flex-col items-center justify-center w-full sm:w-32 h-20 sm:h-32 bg-white border-2 border-dashed border-indigo-300 rounded-lg sm:rounded-xl cursor-pointer hover:bg-indigo-50 hover:border-indigo-400 transition-colors shadow-sm group">
                <span className="text-xl sm:text-2xl mb-1 group-hover:scale-110 transition-transform">📸</span>
                <span className="text-[10px] sm:text-xs font-bold text-indigo-600">Select Images</span>
                <input
                  type="file"
                  disabled={loading}
                  accept="image/*"
                  multiple
                  onChange={handleFilesChange}
                  className="hidden"
                />
              </label>

              {/* Image Previews */}
              {previews.map((src, index) => (
                <div key={index} className="relative w-20 h-20 sm:w-32 sm:h-32 rounded-lg sm:rounded-xl border-2 border-slate-200 overflow-hidden shadow-sm group animate-in zoom-in duration-200">
                  <img src={src} alt={`Preview ${index}`} className="w-full h-full object-cover group-hover:opacity-75 transition-opacity" />
                  <button
                    onClick={() => handleRemoveImage(index)}
                    className="absolute top-1 right-1 bg-rose-500/90 text-white rounded-full w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center text-[10px] sm:text-xs font-bold hover:bg-rose-600 transition-colors shadow-md backdrop-blur-sm"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>

            {/* Read Image Action */}
            {previews.length > 0 && (
              <button
                onClick={extractTextFromImages}
                disabled={loading}
                className="mt-4 sm:mt-5 w-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-2.5 sm:p-3.5 rounded-lg sm:rounded-xl font-bold text-[11px] sm:text-sm hover:shadow-lg hover:shadow-purple-500/30 transition-all duration-300 disabled:opacity-50 flex justify-center items-center gap-2"
              >
                {loading ? (
                  <><div className="w-3 h-3 sm:w-4 sm:h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div> Reading Images...</>
                ) : '🧠 Extract Text from Images'}
              </button>
            )}
          </div>

          {/* Question & Answer Textarea */}
          <div className="space-y-1 sm:space-y-2 mb-6 sm:mb-8 max-w-4xl mx-auto">
            <label className="block text-[11px] sm:text-sm font-bold text-slate-700 ml-1">Your Question & Answers</label>
            <div className="relative">
              <textarea
                ref={textAreaRef}
                className="w-full bg-slate-50 border-2 border-slate-200 rounded-md sm:rounded-xl p-3 sm:p-4 text-[11px] sm:text-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 outline-none resize-y h-24 sm:h-32 custom-scrollbar pb-6 sm:pb-8"
                value={Question}
                onChange={e => {
                  if (e.target.value.length <= 500) setQuestion(e.target.value);
                }}
                placeholder="Type your question and answer here, or let the AI extract it from your images..."
              />
              <div className="absolute bottom-2 right-2 sm:bottom-3 sm:right-3 text-[9px] sm:text-xs font-bold text-slate-400 bg-slate-50/80 px-1 rounded">
                {Question.length}/500
              </div>
            </div>
          </div>

          {/* Action Button */}
          <div className="max-w-4xl mx-auto">
            <button 
              onClick={handleGenerate} 
              disabled={loading}
              className="w-full bg-slate-900 text-white p-2.5 sm:p-4 rounded-lg sm:rounded-2xl font-bold text-[11px] sm:text-base hover:bg-indigo-600 transition-all duration-300 shadow-lg hover:shadow-indigo-500/30 flex justify-center items-center gap-2 disabled:opacity-50"
            >
              ✨ Check My Answer
            </button>
            
            {/* Status Message */}
            {message && (
              <p className="text-center text-[10px] sm:text-sm font-bold text-indigo-500 animate-pulse mt-3 sm:mt-4">
                {message}
              </p>
            )}
          </div>

          {/* Preview Result */}
          {aiResult && (
            <div className="mt-6 sm:mt-10 pt-4 sm:pt-8 border-t border-slate-200 space-y-3 sm:space-5 max-w-4xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-500">
              <div className="flex flex-row items-center justify-between">
                <label className="text-[13px] sm:text-lg font-bold text-slate-800">Feedback & Corrections</label>
              </div>
              
              <textarea 
                className="w-full bg-white text-slate-900 font-mono text-[10px] sm:text-sm leading-tight sm:leading-relaxed p-3 sm:p-5 rounded-lg sm:rounded-2xl border-2 border-slate-200 outline-none h-48 sm:h-80 resize-y focus:border-indigo-400 focus:ring-4 focus:ring-indigo-500/10 transition-all custom-scrollbar" 
                value={aiResult} 
                readOnly 
              />
            </div>
          )}

          <footer className="mt-8 sm:mt-14 text-center text-slate-400 text-[9px] sm:text-xs font-medium">
            © {new Date().getFullYear()} Eascode All Rights Reserved.
          </footer>
        </div>
      </div>
    </>
  );
}




export default CheckMyAnswer;
